import React, { useEffect, useState } from "react";
import { loadYaml } from "../utils/loadYaml";
import { HeroSection } from "../components/herosection";
import { BifurcatedPromo } from "../components/BifurcatedPromo";
import { FeatureGrid } from "../components/FeatureGrid";
import { TeamSection } from "../components/TeamSection";

interface Section {
  type: string;
  id?: string; // optional id for anchor links
  [key: string]: any;
}

interface SectionsData {
  sections: Section[];
}

export const Innovation: React.FC = () => {
  const [sections, setSections] = useState<Section[]>([]);

  useEffect(() => {
    loadYaml("/config/innovation.yaml").then((data: SectionsData) => {
      setSections(data.sections);
    });
  }, []);

  return (
    <div>
      {sections.map((s, idx) => {
        switch (s.type) {
          case "hero":
            return <HeroSection carousel={[]} key={idx} {...s} id={s.id} />;
          case "bifurcatedPromo":
            return (
              <BifurcatedPromo
                key={idx}
                title={s.title || ""}
                left={s.left || { title: "", description: "" }}
                right={s.right || { title: "", description: "" }}
                id={s.id}
              />
            );
          case "featureGrid":
            return (
              <FeatureGrid
                key={idx}
                title={s.title || ""}
                features={s.features || []}
                id={s.id}
              />
            );
          case "team":
            return (
              <TeamSection
                key={idx}
                title={s.title || ""}
                subtitle={s.subtitle || ""}
                members={s.members || []}
                id={s.id}
              />
            );
          default:
            return null;
        }
      })}
    </div>
  );
};

export default Innovation;
